import { UserSettingsKey, GetUserSettingsResponse } from "./types";
import { dashboardBFF } from "../axios-instances";
import { getServices } from "src/logs";

const { logger } = getServices();

export const getUserSetting = async (key: UserSettingsKey) => {
  try {
    const url = `/api/user-settings/${key}`;
    const response = await dashboardBFF.get(url, {
      headers: {
        "Content-type": "application/json"
      }
    });
    if (response.status === 204) {
      const err = new Error("No content, http status code: 204 - Tile Visibility set to true");
      throw err;
    }
    return response.data as GetUserSettingsResponse;
  } catch (error) {
    const err = error as Error;
    if (!err.message.includes("204")) {
      logger.logError({
        message: "getUserSetting - Exception",
        properties: {
          name: err.name,
          message: err.message,
          stack: err.stack || "unknown stack",
          cause: String(err.cause ?? "unknown cause")
        }
      });
    }

    throw error;
  }
};

